import {
  Radio as RadioIcon,
  Instagram as InstagramIcon,
  List as ListIcon
} from "react-feather";

import InstagramSearch from "pages/instagram/InstagramSearch";
import SocialMediaProfile from "pages/socialmedia/SocialMediaProfile";
import VoicesMassSearch from "pages/voices/msearch/VoicesMSearch";
import VoicesLogs from "pages/voices/log/VoicesLogs";
import VoicesResults from "pages/voices/msearch/VoicesMSearchResult";
import VoiceView from "pages/voices/view";
import LogsRecoveries from "pages/logs/LogsRecoveries";
import VoiceRecovery from "pages/voices/Recovery";
import VoiceRecoveryResults from "pages/voices/RecoveryResults.jsx";
import VoiceMassImportView from "pages/voices/massImport/MassImportView";
import VoiceNewMassImportView from "pages/voices/newMassImport/NewMassImportView";
import OrphanMassImportView from "pages/socialmedia/massImport/MassImportView";
import OrphanMSearch from "pages/socialmedia/orphan/OrphanMSearch";
import OrphanMSearchResults from "pages/socialmedia/orphan/OrphanMSearchResult";
import VoiceMergeView from "pages/voices/merge/VoiceMergeView";
// Deepblue generic pages
import DeepBlueLanding from "pages/deepBlue/Landing";

// BSSO
import AuthConnect from "pages/bsso/AuthConnect";
import LogoutConnect from "pages/bsso/LogoutConnect";

// Error Pages
import Error401 from "pages/errors/401";
import Error404 from "pages/errors/404";
import Error500 from "pages/errors/500";
import VoicesSearch from "pages/voices/search/VoicesSearch";
import VoicesValidationSearch from "pages/voices/validation/search/VoicesValidationSearch";
import VoicesValidationManageLists from "pages/voices/validation/manageLists/VoicesValidationManageLists";

const deepBlueLanding = {
  path: "/",
  name: "Home",
  component: DeepBlueLanding,
  children: null
};

const voicesRoutes = {
  name: "Voices",
  icon: RadioIcon,
  children: [
    {
      path: "/voices/search",
      name: "Search",
      component: VoicesSearch
    },
    {
      path: "/voices/msearch",
      name: "Mass Search",
      component: VoicesMassSearch
    },
    {
      path: "/voices/recovery",
      name: "Mass Recovery",
      component: VoiceRecovery
    },
    {
      path: "/voices/import",
      name: "Mass Import",
      component: VoiceMassImportView
    },
    {
      path: "/voices/new-import",
      name: "New Mass Import",
      component: VoiceNewMassImportView
    },
    {
      path: "/voices/merge",
      name: "Merge",
      component: VoiceMergeView
    }
  ]
};

const validationRoutes = {
  name: "Validation",
  children: [
    {
      path: "/voices/validation/search",
      name: "Validation",
      component: VoicesValidationSearch
    },
    {
      path: "/voices/validation/manage-lists",
      name: "Manage Lists",
      component: VoicesValidationManageLists
    }
  ]
};

const voiceHiddenRoutes = {
  path: "/voices",
  name: "Voices",
  icon: RadioIcon,
  exact: false,
  children: [
    {
      path: "/voices/new",
      name: "New Voice",
      component: VoiceView
    },
    {
      path: "/voices/:id(\\d+)",
      name: "Detail",
      component: VoiceView
    },
    {
      path: "/voices/msearch/results",
      name: "Mass Search Result",
      component: VoicesResults
    },
    {
      path: "/voices/recovery/results",
      name: "Recovery Results",
      component: VoiceRecoveryResults
    },
    {
      path: "/voices/import/status/:identifier?",
      name: "Mass Import Detail",
      component: VoiceMassImportView
    },
    {
      path: "/voices/new-import/status/:identifier?",
      name: "New Mass Import Detail",
      component: VoiceNewMassImportView
    },
    {
      path: "/voices/logs/:id(\\d+)",
      name: "Voices Logs",
      component: VoicesLogs
    }
  ]
}

const instagramRoutes = {
  path: "/instagram",
  name: "Instagram",
  icon: InstagramIcon,
  header: "SOCIAL PROFILES",
  exact: false,
  children: [
    {
      path: "/instagram/search",
      name: "Instagram Search",
      component: InstagramSearch
    }
  ]
};

const instagramHiddenRoutes = {
  path: "/instagram",
  name: "Instagram",
  icon: InstagramIcon,
  exact: false,
  children: [
    {
      path: "/instagram/search",
      name: "Search",
      component: InstagramSearch
    },
    {
      path: "/instagram/profile",
      name: "Profile",
      component: SocialMediaProfile
    },
    {
      path: "/instagram/explore/:identifier",
      name: "Explore",
      component: SocialMediaProfile
    }
  ]
};

const youtubeHiddenRoutes = {
  path: "/youtube",
  name: "Youtube",
  exact: false,
  children: [
    {
      path: "/youtube/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const tiktokHiddenRoutes = {
  path: "/tiktok",
  name: "TikTok",
  exact: false,
  children: [
    {
      path: "/tiktok/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const facebookHiddenRoutes = {
  path: "/facebook",
  name: "Facebook",
  exact: false,
  children: [
    {
      path: "/facebook/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const twitterHiddenRoutes = {
  path: "/twitter",
  name: "Twitter",
  exact: false,
  children: [
    {
      path: "/twitter/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const weiboHiddenRoutes = {
  path: "/weibo",
  name: "Weibo",
  exact: false,
  children: [
    {
      path: "/weibo/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const douyinHiddenRoutes = {
  path: "/douyin",
  name: "Douyin",
  exact: false,
  children: [
    {
      path: "/douyin/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const xiaohongshuHiddenRoutes = {
  path: "/xiaohongshu",
  name: "Xiaohongshu",
  exact: false,
  children: [
    {
      path: "/xiaohongshu/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const bilibiliHiddenRoutes = {
  path: "/bilibili",
  name: "Bilibili",
  exact: false,
  children: [
    {
      path: "/bilibili/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const wechat_publicHiddenRoutes = {
  path: "/wechat_public",
  name: "Wechat_public",
  exact: false,
  children: [
    {
      path: "/wechat_public/profile",
      name: "Profile",
      component: SocialMediaProfile
    }
  ]
};

const bssoAuthRoutes = {
  path: "/bsso",
  name: "AuthConnect",
  icon: InstagramIcon,
  exact: false,
  children: [
    {
      path: "/bsso/connect",
      component: AuthConnect
    },
    {
      path: "/bsso/logout",
      component: LogoutConnect
    }
  ]
};

const errorRoutes = {
  path: "/error",
  name: "Error",
  children: [
    {
      path: "/error/401",
      name: "401 Page",
      component: Error401
    },
    {
      path: "/error/404",
      name: "404 Page",
      component: Error404
    },
    {
      path: "/error/500",
      name: "500 Page",
      component: Error500
    }
  ]
}

const logsRoutes = {
  path: "/logs",
  name: "Logs",
  icon: ListIcon,
  children: [
    {
      path: "/logs/recoveries",
      name: "Recoveries",
      component: LogsRecoveries
    }
  ]
};

const orphanRoutes = {
  path: "/orphan",
  name: "Orphan",
  children: [
    {
      path: "/orphan/msearch",

      name: "Mass Search",

      component: OrphanMSearch
    },
    {
      path: "/orphan/import",
      name: "Mass Import",
      component: OrphanMassImportView
    }
  ]
}

const orphanHiddenRoutes = {
  path: "/orphan",
  name: "Orphan",
  children: [
    {
      path: "/orphan/import/status",
      name: "Mass Import Detail",
      component: OrphanMassImportView
    },
    {
      path: "/orphan/msearch/results",
      name: "Mass Search Result",
      component: OrphanMSearchResults
    }
  ]
}

// Error pages
export const errorPageRoutes = [errorRoutes]

// BSSO
export const bssoRoutes = [bssoAuthRoutes];

// Deepblue routes
export const deepblueRoutes = [
  deepBlueLanding,
  instagramHiddenRoutes,
  youtubeHiddenRoutes,
  tiktokHiddenRoutes,
  facebookHiddenRoutes,
  twitterHiddenRoutes,
  voicesRoutes,
  validationRoutes,
  voiceHiddenRoutes,
  logsRoutes,
  orphanRoutes,
  orphanHiddenRoutes,
  weiboHiddenRoutes,
  douyinHiddenRoutes,
  xiaohongshuHiddenRoutes,
  bilibiliHiddenRoutes,
  wechat_publicHiddenRoutes
];

// Routes for the sidebar
/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
  voicesRoutes,
  validationRoutes,
  orphanRoutes,
  instagramRoutes,
  logsRoutes
];
